import React from "react";
import { Progress } from "antd-mobile";
import CountDownButton from "./js/countdown";
import "./index.less";

export default function PageLayout({
  children,
  changeChildren,
  surveyInfo,
  sampleInfo,
}) {
  const { preferences: { progress, lastButton, nextButton } = {} } = surveyInfo;
  const { questions: [{ preferences: { countdown } = {} }] = [{}] } =
    sampleInfo;

  // 下一题
  const onNextClick = () => {
    if (changeChildren) {
      changeChildren(1);
    }
  };

  // 上一题
  const onPreClick = () => {
    if (changeChildren) {
      changeChildren(-1);
    }
  };

  // 重置
  const onResetClick = () => {
    changeChildren(0);
  };

  return (
    <div className="layout">
      <div className="layout-header">
        <div className="survey-title">{surveyInfo.alias || ""}</div>
        <div className="show-info">
          {+progress === 1 && (
            <div className="progress">
              <Progress
                percent={sampleInfo.percent ? sampleInfo.percent : 0}
                position="normal"
              />
            </div>
          )}

          <div aria-hidden="true">
            {sampleInfo.percent ? sampleInfo.percent : 0}%
          </div>
        </div>
      </div>
      <div className="layout-body">
        <div className="question-content">{children}</div>
        <div className="page-buttons">
          <CountDownButton
            className="page-button"
            countdown={countdown}
            onClick={onNextClick}
            btnText={nextButton}
          />
          <div
            className="page-button"
            dangerouslySetInnerHTML={{
              __html: (lastButton || "&lt;")
                .replace(/<p><\/p>/g, "<br />")
                .replace(/\n\n/g, "<br />")
                .replace(/\s{2}/g, "&nbsp;&nbsp;"),
            }}
            onClick={onPreClick}
          />
          <div className="page-button reset" onClick={onResetClick}>
            C
          </div>
        </div>
      </div>
    </div>
  );
}

PageLayout.defaultProps = {
  surveyInfo: {},
  sampleInfo: {},
};
